module.exports = __webpack_public_path__ + "img/20180815_152858_228.e7de67a4.jpg";